//noinspection JSUnusedGlobalSymbols

/**
 * ESA Component: Client Controller (Site)
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"

//const utils = window.Hive.getUtils();

class ClientController extends Controller {
  static CID = 'client'

  static NAME = 'Client'

  formElement

  initiate() {
    super.initiate();

    const form = document.querySelector('[data-client-form]');
    if (!form) return;

    this.formElement = form;
    this.formHandler = window.Hive.getFormHandler(this, this.formElement);

    let url = window.location.origin + '/index.php?option=com_esa&format=json';
    this.callHandler = window.Hive.getCallHandler(this, url);

    // Track changes
    this.formHandler.track((formData) => this.trackForm(formData));

    // if (Number(stateElement.value) === 0) stateElement.dispatchEvent(new Event('change'));
  }

  /**
   *
   * @param {FormData} formData
   */
  trackForm(formData) {
    // Check if privacy field exists
    if (typeof this.formElement['jform[privacyconsent][privacy]'] !== 'undefined') return;

    //const requestData = new FormData();
    formData.append('request', 'client.observe');
    this.callHandler.postRequest('api.post',
      formData,
      (success, responseData) => {
        if (success) this.updateForm(responseData);
      })
  }

  updateForm(data) {
    let dhg_required = data.client['dhg_required'] || '0';
    document.getElementById('jform_client_dhg_required').value = dhg_required;

    const dhgInfoElement = document.getElementById('jform_client_dhg_required_info');
    if (dhgInfoElement) {
      if (dhg_required) {
        dhgInfoElement.classList.add('show');
      } else {
        dhgInfoElement.classList.remove('show');
      }
    }

    let nameValue = data['name'] || '';
    const nameElement = document.getElementById('jform_name');
    if (nameElement && nameValue.length) nameElement.value = nameValue;

  }
}

export default ClientController
